<template>
  <div>
    404
    <van-button plain hairline type="primary" to="/home" size="small">首页</van-button>
    <van-button plain hairline type="primary" to="/user" size="small">用户中心</van-button>
  </div>
</template>

<script>
export default {
  name: 'errorPage',
  data () {
    return {}
  },
  components: {},
  methods: {},
  mounted () {}
}
</script>

<style lang="less" scoped>
</style>
